/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function($) {
	"use strict";
	/*globals Tc */

	/**
	 * Brightcove Overlay
	 *
	 * @author Zeljko Curcic
	 * @namespace Tc.Module
	 * @class BrightcoveOverlay
	 * @extends Tc.Module
	 */
	Tc.Module.BrightcoveOverlay = Tc.Module.extend({

		on: function(callback) {
			var mod = this,
				$ctx = mod.$ctx,
				$video = $ctx.children('.brightcove-video-container');


			$ctx.on('click', '.overlay-link', function(e){
				e.preventDefault();
				mod.createOverlay($video);
			});

			callback();
		},
		createOverlay : function($video){
			var mod = this,
				$ctx = mod.$ctx,
				$link = $ctx.children('.overlay-link'),
				videoWidth = $link.data('lightbox-width'),
				videoHeight = $link.data('lightbox-height');

			if (!$video.is(':data(ui-dialog)')){
				$video.dialog({
					classes: {'ui-dialog': 'ui-brightcove-overlay'},
					title : '',
					autoOpen : false,
					width : videoWidth,
					minHeight : videoHeight,
					appendTo : $ctx
				});
			}
			$video.dialog('open');
		}
	});
}(Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/desktop/js/modules/Tc.Module.BrightcoveOverlay.js
// module id = 131
// module chunks = 0